import { getClassNames } from '@websolutespa/bom-core';
import { useLabel } from '@websolutespa/bom-mixer-hooks';
import style from './page-loading.module.scss';

export const PageLoading: React.FC = () => {
  const label = useLabel();
  return (
    <div className={getClassNames(style.container)}>
      <div className={style.title}>{label('llm.thinking')}</div>
      <div className={style.loading}>
        <span>&nbsp;</span>
        <span>&nbsp;</span>
        <span>&nbsp;</span>
      </div>
    </div>
  );
};
